import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  DialogActions,
  Button,
  Tabs,
  Tab,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import WorkOrderLogList from './work-order-log-list';
import { TabPanel } from '../../../../components/tab-panel';
import DuxSyncLogList from './dux-sync-log-list';
import EmailLogList from './email-log-list';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface WorkorderLogDialogProps {
  open: boolean;
  onClose: () => void;
}

export const WorkOrderLogDialog = ({ open, onClose }: WorkorderLogDialogProps) => {
  // const [selectedServiceID, setSelectedServiceID] = useState<number>(0);
  const handleDialogClose = () => {
    onClose();
  };

  const [value, setValue] = useState('work-order-logs');

  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'lg'}
      // onClose={handleDialogClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ p: 0, m: 0 }}>
        <Tabs value={value} onChange={handleTabsChange}>
          <Tab value="work-order-logs" label={<div style={styling.tabHeading}>WORK ORDER LOGS</div>} />
          <Tab value="dux-sync-logs" label={<div style={styling.tabHeading}>DUX SYNC LOGS</div>} />
          <Tab value="email-logs" label={<div style={styling.tabHeading}>EMAIL LOGS</div>} />
        </Tabs>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog selectServiceList">
        <TabPanel selectedValue={value} value="work-order-logs">
          <WorkOrderLogList />
        </TabPanel>
        <TabPanel selectedValue={value} value="dux-sync-logs">
          <DuxSyncLogList />
        </TabPanel>
        <TabPanel selectedValue={value} value="email-logs">
          <EmailLogList />
        </TabPanel>
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={handleDialogClose}>
            Cancel
          </Button>
          {/* <Button
            type={'button'}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            disabled={isSaving || !selectedServiceID}
            onClick={handleSaveClick}
          >
            Save
          </Button> */}
        </DialogActions>
      </div>
    </Dialog>
  );
};
